import { createReducer, on } from "@ngrx/store";
import { ApuStandardCategoryActions } from "./apu-standard-category.actions";
import { apuStandardCategoryAdapter } from "./apu-standard-category.state";
import { initialApuStandardCategory } from "./apu-standard-category.state";

export const apuStandardCategoryReducer = createReducer(
    initialApuStandardCategory,
    on(ApuStandardCategoryActions.loadApuStandardCategorySuccess, (state, action) => {
        return apuStandardCategoryAdapter.setAll(action.apuStandardCategories, {
            ...state,
            errorMessage: null
        });
    })
);